import { render, staticRenderFns } from "./ProfilePhoto.vue?vue&type=template&id=6d9c9ec0"
import script from "./ProfilePhoto.vue?vue&type=script&lang=ts"
export * from "./ProfilePhoto.vue?vue&type=script&lang=ts"
import style0 from "./ProfilePhoto.vue?vue&type=style&index=0&id=6d9c9ec0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports